import React from 'react'
import { Container, Row, Col, Button } from "react-bootstrap";
import Particle from '../Atom';
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillMail,
  AiFillPhone
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa"
const Contact = () => {
  return (
    
    <section>
      <Container fluid className="homecontainer" >
      <Particle />  
        <Container className="homesubcontainer">
          <Row>
          <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src='https://pxmatrix.com/wp-content/uploads/2021/09/mernstack-dev.png'
                alt="homeimage"
                className="homepic"
                style={{ maxHeight: "750px", marginTop:'80px',width:'80%'}}
              />
            </Col>
            <Col md={7} className="home-header">
            <form id="contact-form">

      <div className="form-group">
        <div className="field">
          <input type="text"  placeholder="Name"  />
          <i className='fas fa-user'></i>
        </div>
        <div className="field">
          <input type="text" name="email" placeholder="Email" />
          <i className='fas fa-envelope'></i>
        </div>
        <div className="field">
          <input type="text" name="phone" placeholder="Phone"/>
          <i className='fas fa-phone-alt'></i>
        </div>
        <div className="message">
        <textarea placeholder="Message" name="message"></textarea>
        <i className="fas fa-comment-dots"></i>
        </div>
        </div>
      <div className="button-area">
        <Button type="submit" className='btn54'>
          Submit <i className="fa fa-paper-plane"></i></Button>
      </div>
    </form>
            </Col>

            
          </Row>
          <Row>
          <Col md={12} className="socialhome">
            <h1 style={{ fontSize: "2.6em",color:'aqua' }}>Contact Me</h1>

            <ul className="homesocialinks">
              <li className="socialiconshome">
                <a
                  href="https://github.com/Rutujalomate"
                  target="_blank"
                  rel="noreferrer"
                  className="socialiconsre"
                >
                  <AiFillGithub />
                </a>
              </li>
             
              <li className="socialiconshome">
                <a
                  href="https://www.linkedin.com/in/lomate-rutuja-1aa4bb238/"
                  target="_blank"
                  rel="noreferrer"
                  className="socialiconsre"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="socialiconshome">
                <a
                  href="lomaterutuja1506@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="socialiconsre"
                >
                  <AiFillMail />lomaterutuja1506@gmail.com
                </a>
              </li>
              <li className="socialiconshome">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="socialiconsre"
                >
                  <AiFillPhone />9370060152
                </a>
              </li>

            </ul>
          </Col>
        </Row>
        </Container>
      </Container>
    </section>
  
  )
}

export default Contact